import axios from "axios";
import {
  Toast
} from 'vant';

//let baseURL = ' http://192.168.5.2:8084/'
let baseURL = ' https://fcpg.shnsshrcb.com/api/'
const instance = axios.create({
  baseURL: baseURL,
  timeout: 30000
});

instance.interceptors.response.use(
  response => {
    // 定时刷新access-token
    return response;
  },
  error => {
    //return Promise.reject(error);
    return Promise.reject({
      msg: error.response.data.msg ?
        error.response.data.msg : error.response.data.message,
      res: error.response
    });
  }
);


function baseRequest(options) {
  const headers = options.headers || {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('auth')
  };
  options.headers = headers;
  return instance(options).then(res => {
    const data = res.data || {};
    if (res.data.code == 401) {
      Toast('身份过期，重新登录中');
      localStorage.removeItem('auth')
      window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww70fd72735961d8b1&redirect_uri=https://fcpg.shnsshrcb.com&response_type=code&scope=snsapi_privateinfo&state=STATE&agentid=1000039#wechat_redirect';
    }
    if (res.data.code !== 200) {
      Toast(res.data.msg);
      return Promise.reject({
        msg: "请求失败",
        res,
        data
      });
    }

    if (data.code == 200) {
      return Promise.resolve(data, res);
    } else {
      Toast(data.msg);
      return Promise.reject({
        msg: res.data.msg,
        res,
        data
      });
    }
  }).catch(e => {
    if (e.res.status == 401) {
      Toast('登陆过期');
      localStorage.removeItem('auth');
      window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww70fd72735961d8b1&redirect_uri=https://fcpg.shnsshrcb.com&response_type=code&scope=snsapi_privateinfo&state=STATE&agentid=1000039#wechat_redirect';
    }
    if (e.res.status !== 200) {
      Toast('请求失败');
      return Promise.reject(e);
    }
  });
}

/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
const request = ["post", "put", "patch"].reduce((request, method) => {
  /**
   *
   * @param url string 接口地址
   * @param data object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, data = {}, options = {}) => {
    return baseRequest(
      Object.assign({
        url,
        data,
        method
      }, options)
    );
  };
  return request;
}, {});

["get", "delete", "head"].forEach(method => {
  /**
   *
   * @param url string 接口地址
   * @param params object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, params = {}, options = {}) => {
    return baseRequest(
      Object.assign({
        url,
        params,
        method
      }, options)
    );
  };
});

export default request;